import { render, staticRenderFns } from "./MiniGamesPage.vue?vue&type=template&id=8f778b28&scoped=true"
import script from "./MiniGamesPage.vue?vue&type=script&lang=js"
export * from "./MiniGamesPage.vue?vue&type=script&lang=js"
import style0 from "./MiniGamesPage.vue?vue&type=style&index=0&id=8f778b28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f778b28",
  null
  
)

export default component.exports